module.exports = __webpack_public_path__ + "static/media/bcsgQAScreen2.da844172.jpg";